module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 map-sidebar"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('origin')
    }
  }, [_c('label', {
    staticClass: "label-trip"
  }, [_vm._v("Origem:")]), _vm._v(" "), _c('i', {
    staticClass: "pin-origin"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-add-pin",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Adicionar um local de passagem"
    },
    on: {
      "click": _vm.addWayPoint
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-origin",
    attrs: {
      "name": "origin",
      "id": "origin",
      "placeholder": "Digite um local de origem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('origin')) + "\n      ")])]), _vm._v(" "), _vm._l((20), function(o, i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i < _vm.qtdWayPoints),
        expression: "i < qtdWayPoints"
      }],
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "label-trip"
    }, [_vm._v("Passagem:")]), _vm._v(" "), _c('i', {
      staticClass: "pin-waypoint"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-del-pin",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Remover local de passagem"
      },
      on: {
        "click": _vm.removeWayPoint
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })]), _vm._v(" "), _c('input', {
      staticClass: "form-control input-origin",
      attrs: {
        "name": 'waypoint' + i,
        "id": 'waypoint' + i,
        "placeholder": "Digite um local de passagem"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "help-block"
    }, [_vm._v("\n          " + _vm._s(_vm.errors.first('waypoint' + i)) + "\n        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('destination')
    }
  }, [_c('label', {
    staticClass: "label-trip"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('i', {
    staticClass: "pin-destination"
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control input-destination",
    attrs: {
      "name": "destination",
      "id": "destination",
      "placeholder": "Digite um local de destino"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('origin')) + "\n      ")])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-error margin-t10"
  }, [_vm._v("\n      " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('label', {
    staticClass: "block-round-trip"
  }, [_vm._v("Ida e volta?")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-axis"
  }, [_c('label', {
    staticClass: "block-round-trip"
  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.axes),
      expression: "axes"
    }],
    staticClass: "form-control input-axis",
    attrs: {
      "type": "number",
      "name": "axis-number",
      "value": "2"
    },
    domProps: {
      "value": (_vm.axes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.axes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coord),
      expression: "coord"
    }],
    staticClass: "form-control input-destination",
    attrs: {
      "placeholder": "Coordenada"
    },
    domProps: {
      "value": (_vm.coord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-calculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.plotar
    }
  }, [_vm._v("\n      Plotar\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.associateId),
      expression: "associateId"
    }],
    staticClass: "form-control input-destination",
    attrs: {
      "placeholder": "associateId"
    },
    domProps: {
      "value": (_vm.associateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.associateId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-calculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.plotAssociate
    }
  }, [_vm._v("\n      Plotar\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-calculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.inverter
    }
  }, [_vm._v("\n      Inverter\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-calculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("\n      Calcular\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showSummary) ? _c('div', {
    staticClass: "result-calculate-trip"
  }, [_c('ul', {
    staticClass: "trip-summary-box"
  }, [_c('li', [_c('i', {
    staticClass: "icon-road"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Distância:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.result.totalDistance) + " Km")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("secondsFormat")(_vm.result.totalTime)))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-toll"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Qtd. de Pedágios:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.result.tolls.length))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-coin"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Valor Pedágios:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bs-callout bs-callout-primary"
  }, [_vm._v("\n        Sua viagem irá custar "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))]), _vm._v(" em pedágios.\n        Deseja fazer uma recarga?\n      ")]), _vm._v(" "), _vm._m(4)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 map-area"
  }, [_c('div', {
    ref: "map",
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Viagem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "margin-b20"
  }, [_vm._v("\n        Calcule a distância, o tempo estimado e o custo de pedágios da sua viagem, para isso é só preencher os campos abaixo e clicar em calcular:\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "onoffswitch-label",
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("\n            Tempo Estimado:\n            "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "O tempo é estimado usando como base um veículo de passeio (2 eixos) na velocidade média das vias."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-recharge-fit"
  }, [_vm._v("\n        Recarregar "), _c('b', [_vm._v("R$ 50,00")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-dc13bdf0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/routing/routing-teste.vue
// module id = 2219
// module chunks = 1